import { render, staticRenderFns } from "./TrailerButton.vue?vue&type=template&id=66ff1d1f"
import script from "./TrailerButton.vue?vue&type=script&lang=js"
export * from "./TrailerButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports